import { t } from '@trimble/i18n';
import { Component, ErrorBoundary, JSX } from 'solid-js';
import { NotificationEventBus } from '@trimble/solidjs-notifications';

interface ErrorBoundaryHandlerProps {
  children: JSX.Element;
}

export const ErrorBoundaryHandler: Component<ErrorBoundaryHandlerProps> = (
  props
) => {
  return (
    <ErrorBoundary
      fallback={(err) => {
        console.error('Error caught', err);
        NotificationEventBus.emit({
          type: 'error',
          message: t('general.unhandledError'),
        });
        return props.children;
      }}
    >
      {props.children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryHandler;
